export enum SearchType {
  Entity = 'entity',
  Contract = 'contract',
  Agreement = 'agreement',
  PartyAgreement = 'partyagreement',
  Form = 'form',
  Condition = 'condition',
  TeamSet = 'teamset',
  Claim = 'claim',
  Document = 'document',
  ContractProfile = 'contractprofile',
  Employee = 'employee',
  Workgroup = 'workgroup',
  IntegrationServiceConfig = 'integrationserviceconfig',
  IntegrationActionConfig = 'integrationactionconfig',
  Broker = 'broker',
  Supplier = 'supplier',
  Provider = 'provider',
  CodeSet = 'codeset',
  ClassCode = 'classcode',
  ContractInterestThirdParty = 'contractinterestthirdparty',
  Invoice = 'invoice',
  Statement = 'statement'
}

export enum SearchActionType {
  Select = 'select',
  Clear = 'clear',
  Close = 'close',
  Cancel = 'cancel'
}

export enum SearchStatus {
  Ready = 'ready',
  InProgress = 'inProgress',
  SingleResult = 'singleResult'
}

export interface SearchResultType {
  action: SearchActionType;
  count?: number;
  data?: any[];
}

export interface SearchOptionsType {
  allowClear?: boolean;
  autoSearch?: boolean;
  allowMultiSelect?: boolean;
  maxRows?: number;
  maxRowLimiter?: boolean;
  minSearchLength?: number;
  debounceTime?: number;
  modelProperty?: string;
  descriptionProperty?: string;
  tooltip?: string;
}

export interface SearchInputModel {
  currentOptions: SearchOptionsType;
  criteria: any;
  dirty: boolean;
  objectType: string;
  searchText: string;
}
